export default __webpack_public_path__ + "media/images/features/hida/hida-tourism-association-7be2c6dee92aeb2b5c23c7e193fa5c84.png";